import { Avatar } from '@delmonicos/shared-design-system-react/src/components/avatar/avatar';
import { ButtonIcon } from '@delmonicos/shared-design-system-react/src/components/button-icon/button-icon';
import { ButtonColor } from '@delmonicos/shared-design-system-react/src/components/button/button';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { LogoCPMS } from '@app/shared/logo-cpms/logo-cpms';
import { useCpmsBoGetMeQuery } from '@service/cpms-bo-user-me.service';

export const Header = (): React.JSX.Element => {
  const navigate = useNavigate();
  const { data: user } = useCpmsBoGetMeQuery();

  return (
    <header>
      <LogoCPMS />

      <Stack gap={GapEnum.XS} alignItems="center" justifyContent="center">
        <ButtonIcon
          color={ButtonColor.Ghost}
          onClick={() => navigate(APP_PATH.SETTINGS)}
          icon="settings-02"
        />
        <Avatar
          firstName={user?.firstName ?? ''}
          lastName={user?.lastName ?? ''}
          onClick={() => navigate(APP_PATH.PROFILE)}
        />
      </Stack>
    </header>
  );
};
